export default "__VITE_ASSET__d8149d85__"